import React from 'react';
import { Typography } from '@mui/material';
import Order from '@components/order/models/list/Order';
import { formatDateTime } from '@utils/dateTimeFormatter';

interface OrderListItemAdministrationProps {
    order: Order;
}

const OrderListItemAdministration: React.FC<OrderListItemAdministrationProps> = ({ order }) => {
    return (
        <>
            <Typography mt={0.5} textAlign={"start"} variant='subtitle2'>{`${order.user?.firstName} ${order.user?.lastName}`}</Typography>
            <Typography textAlign={"start"} variant='subtitle2'>{`Potvrđeno: ${formatDateTime(order.dateEdited)}`}</Typography>
        </>
    )
}

export default OrderListItemAdministration;